import React, { useContext, useEffect, useRef, useState } from 'react';
import { BrowserRouter, Route, useHistory } from 'react-router-dom';

import {
    Box,
    Button,
    CircularProgress,
    TextField,
    Typography,
    Divider,
    Grid,
    InputAdornment,
    MenuItem,
} from '@material-ui/core';
import { useStyles } from '../styles';
import { Store } from '../Store';
import axios from "axios";
import { toast } from '../components/Toast';
import {
    USER_SIGNIN,
    USER_SIGNIN_SUCCESS,
    USER_SIGNIN_FAIL,
} from '../constants';
import config, { merchantCode } from '../util';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import Logo from '../assets/image/cofee.png';
//import splash2 from '../assets/image/splash2.png';

// OTP countdown hook
const useOtpCountdown = (initialTime = 120) => {
    const [timer, setTimer] = useState(0);
    const [isActive, setIsActive] = useState(false);
    const intervalRef = useRef(null);

    const startCountdown = () => {
        if (intervalRef.current) clearInterval(intervalRef.current);
        setTimer(initialTime);
        setIsActive(true);
    };

    useEffect(() => {
        if (isActive) {
            intervalRef.current = setInterval(() => {
                setTimer(prev => {
                    if (prev <= 1) {
                        clearInterval(intervalRef.current);
                        setIsActive(false);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        }
        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, [isActive]);

    const resetCountdown = () => {
        if (intervalRef.current) clearInterval(intervalRef.current);
        setTimer(0);
        setIsActive(false);
    };

    return {
        timer,
        startCountdown,
        resetCountdown,
    };
};

const SignUp = (props) => {
    const styles = useStyles();
    const { state, dispatch } = useContext(Store);
    let { userInfo } = state.userData;
    const [Signin] = useState(false);
    const [signInEmail, setSignInEmail] = useState("");
    const [isGoogleLoading, setIsGoogleLoading] = useState(false);
    const history = useHistory();
    const [isEmail, setIsEmail] = useState(false);
    const [countryCode, setCountryCode] = useState('+91');
    const [otp, setOtp] = useState(["", "", "", ""]);
    const inputRefs = useRef([]);
    const [otpSent, setOtpSent] = useState(false);
    const [isSendingOTP, setOTPSending] = useState(false);
    const [isVerifyingOtp, setIsVerifyingOtp] = useState(false);
    const { timer, startCountdown, resetCountdown } = useOtpCountdown();
    const [passHint, setPassHint] = useState(false);
    const passHints = ["Your Date of birth(DDMMYY)?", "What's your best friend name?", "Your best 1 hobby?", "Your favourite City Name?", "Your Favourite Color?", "Your Favourite Player?", "Your Favourite Actor?", "Your Favourite car brand?", "Your Favourite Shoe brand?", "Your Favourite Dish?"];
    let { setting } = state.userSetting;
    let loggedUser = sessionStorage.getItem("customerInfo") ? JSON.parse(sessionStorage.getItem("customerInfo")) : null;
    console.log(setting);
    if (!setting) {
        setting = JSON.parse(localStorage.getItem("userInfo"));
    }

    useEffect(() => {
        if (loggedUser && loggedUser.customer) {
            props.history.push('/collection-mode?' + window.location.href.split('?')[1]);
        }
    }, []);


    const handleInputChange = (e) => {
        const val = e.target.value;
        setSignInEmail(val);
        setIsEmail(false);
    };

    const handleGoogleSuccess = async (credentialResponse) => {
        if (!credentialResponse.credential) {
            toast.error("Google authentication failed!");
            return;
        }

        setIsGoogleLoading(true);

        try {
            const token = credentialResponse.credential;
            const decodedToken = JSON.parse(atob(token.split('.')[1]));

            decodedToken.firstName = decodedToken.given_name;
            decodedToken.lastName = decodedToken.family_name;
            decodedToken.isEmailVerified = true;

            let response;
            try {
                response = await axios.post(`${config.authapi}/customer/authenticate`, {
                    googleData: decodedToken,
                    token,
                    merchantCode
                });
            } catch (err) {
                response = await axios.post(`${config.authapi}/customer/google-auth`, {
                    token,
                    merchantCode,
                });
            }

            dispatch({
                type: USER_SIGNIN_SUCCESS,
                payload: response.data.user,
            });

            sessionStorage.setItem("customerInfo", JSON.stringify(response.data.user));
            if (window.NativeInterface && response.data.user.token) {
                window.NativeInterface.saveToken(response.data.user.token);
            }
            if (props.setOpenSign && props.procedToCheckoutHandler) {
                props.setOpenSign(false);
                props.procedToCheckoutHandler();
            }
            else {
                setting.branches.length ? history.push('/choose-branch?' + window.location.href.split('?')[1]) :
                    history.push('/collection-mode?' + window.location.href.split('?')[1]);
            }


            setIsVerifyingOtp(false);
            setOtpSent(false);
            resetCountdown();
        } catch (error) {
            console.error("Google Auth Error:", error);
            toast.error("Google authentication failed: " +
                (error.response?.data?.message || error.message));

            dispatch({
                type: USER_SIGNIN_FAIL,
                payload: error.message,
            });
        } finally {
            setIsGoogleLoading(false);
        }
    };

    const handleGoogleError = () => {
        toast.error("Google sign in was unsuccessful. Please try again.");
        setIsGoogleLoading(false);
    };

    const getOtpHandler = async () => {
        // setOTPSending(true);
        const email = signInEmail;
        if (!email) {
            toast.error("Please enter your phone number");
            return;
        }

        if (!/^\d{10,15}$/.test(signInEmail)) {
            toast.error("Please enter a valid phone number (10-15 digits)");
            return;
        }

        try {
            dispatch({ type: USER_SIGNIN });

            const payload = { phone: countryCode + signInEmail, merchantCode, checkExisting: true };

            const response = await axios.post(`${config.authapi}/customer/send-otp`, payload);
            console.log(response);

            if (response.data && response.data.isExistingUser) {
                dispatch({
                    type: USER_SIGNIN_SUCCESS,
                    payload: response.data.user,
                });
                sessionStorage.setItem("customerInfo", JSON.stringify(response.data.user));
                if (window.NativeInterface && response.data.user.token) {
                    window.NativeInterface.saveToken(response.data.user.token);
                }
                if (props.setOpenSign && props.procedToCheckoutHandler) {
                    props.setOpenSign(false);
                    props.procedToCheckoutHandler();
                } else {
                    setting.branches.length ? history.push('/choose-branch?' + window.location.href.split('?')[1]) :
                        history.push('/collection-mode?' + window.location.href.split('?')[1]);
                }
                return;
            }

            if (response) {
                setPassHint("Please check your phone for the OTP");
            } else {
                setPassHint(passHints[Math.floor(Math.random() * passHints.length - 1) + 1]);
            }
            
            setOtpSent(true);
            startCountdown();
            setOTPSending(false);

            toast.success(`OTP sent to your phone`);
        } catch (error) {
            console.error("OTP sending failed:", error);
            toast.error("OTP sending failed. Please try again later");
            dispatch({
                type: USER_SIGNIN_FAIL,
                payload: error.message,
            });
        }
    };

    const verifyOtpHandler = async () => {

        try {
            setIsVerifyingOtp(true);

            const payload = { phone: countryCode + signInEmail, otp: otp.join(""), merchantCode };

            const response = await axios.post(`${config.authapi}/customer/verify-otp`, payload);

            if (response && response.data.user) {
                dispatch({
                    type: USER_SIGNIN_SUCCESS,
                    payload: response.data.user,
                });
                sessionStorage.setItem("customerInfo", JSON.stringify(response.data.user));
                if (window.NativeInterface && response.data.user.token) {
                    window.NativeInterface.saveToken(response.data.user.token);
                }
                if (props.setOpenSign) {
                    props.setOpenSign(false);
                    if (props.procedToCheckoutHandler) props.procedToCheckoutHandler();
                }
                setting.branches.length ? history.push('/choose-branch?' + window.location.href.split('?')[1]) :
                    history.push('/collection-mode?' + window.location.href.split('?')[1]);


                setIsVerifyingOtp(false);
                setOtpSent(false);
                resetCountdown();
            }
        } catch (error) {
            console.error("OTP verification failed:", error);
            toast.error("OTP verification failed. Please try again.");
            setIsVerifyingOtp(false);
            dispatch({
                type: Signin ? USER_SIGNIN_FAIL : USER_SIGNIN_FAIL,
                payload: error.message,
            });
        }
    };

    const handleChangeEmail = () => {
        setOtpSent(false);
        resetCountdown();
        setOtp(["", "", "", ""]);
    };

    const handleOtpChange = (index, value) => {
        if (!/^\d*$/.test(value)) return;
        const newOtp = [...otp];
        newOtp[index] = value.slice(-1);
        setOtp(newOtp);
        
        if (value && index < 3) {
            inputRefs.current[index + 1].focus();
        }
    };

    const handleOtpKeyDown = (index, e) => {
        if (e.key === "Backspace" && !otp[index] && index > 0) {
            inputRefs.current[index - 1].focus();
        }
    };

    const skipLogin = () => {
        localStorage.setItem('isLoginSkipped', 'Y');
        setting.branches.length ? history.push('/choose-branch?' + window.location.href.split('?')[1]) :
            history.push('/order?' + window.location.href.split('?')[1]);

    }

    return (
        <Box
            className={styles.root}
            style={{
                position: props.setOpenSign ? "relative" : "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                zIndex: 9999, // Ensure it's above all other elements
                overflowY: "auto",
                padding: "20px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: setting.themeColor
            }}
        >
            <div
                style={{ borderRadius: "7px", }}>

                <Box
                    display="flex"
                    justifyContent="center"
                    mb={2}

                >
                    <img
                        src={setting.logoImg} // Path to the logo from asset folder
                        alt="Welcome!"
                        style={{
                            width: "130px",
                            height: "100px",
                            borderRadius: "10px"
                        }}
                    />
                </Box>

                {!otpSent && (
                    <div style={{ width: "100%" }} id="input_sign">
                        <Typography
                            variant="h4"
                            align="center"
                            gutterBottom
                            style={{
                                marginBottom: "20px",
                                color: setting.themeTxtColor,
                                fontWeight: "600",
                                fontFamily: setting.themePrimaryFontFam

                            }}
                        >
                            Your Details!
                        </Typography>

                        <TextField
                            label="Enter Phone Number"
                            fullWidth
                            required
                            variant="outlined"
                            margin="normal"
                            value={signInEmail}
                            onChange={handleInputChange}
                            style={{
                                fontSize: "1.4em",
                                fontWeight: "normal",
                                fontFamily: setting.themeSecondaryFontFam,
                                backgroundColor: "#212121",
                                borderRadius: "8px",
                                color: "#6f6d6d"
                            }}
                            InputLabelProps={{
                                style: { color: '#6f6d6d' },
                                fontWeight: "bold",
                                color: "#6f6d6d"

                            }}
                            InputProps={{
                                style: { fontSize: "0.8em", fontWeight: "normal" },  // White text
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <TextField
                                            select
                                            value={countryCode}
                                            onChange={(e) => setCountryCode(e.target.value)}
                                            style={{
                                                width: "70px",
                                                fontSize: "1.4em",
                                                fontWeight: "normal",
                                                color: "#ccc",
                                                backgroundColor: "#2a2a2a",
                                            }}
                                            InputProps={{
                                                style: { color: "#ccc" },
                                                color: "#ccc"
                                            }}
                                        >
                                            <MenuItem value="+91">+91</MenuItem>
                                            <MenuItem value="+1">+1</MenuItem>
                                            <MenuItem value="+44">+44</MenuItem>
                                        </TextField>
                                    </InputAdornment>
                                ),
                            }}
                        />

                        <Grid container spacing={2} style={{ marginTop: "15px" }}>
                            <Grid item xs={12}>
                                <Button
                                    variant="contained"
                                    disabled={!signInEmail}
                                    fullWidth
                                    onClick={getOtpHandler}
                                    style={{
                                        backgroundColor: setting.themeTxtColor, // ✅ Fixed: single '#'
                                        color: setting.themeColor,
                                        borderRadius: "8px",
                                        padding: "10px",
                                        fontWeight: "bold",
                                        textTransform: "uppercase",
                                    }}
                                >
                                    NEXT
                                </Button>

                            </Grid>
                        </Grid>

                        {false && <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                            width="100%"
                            my={3}
                        >
                            <Divider style={{ width: '40%', backgroundColor: "#DD9854" }} />
                            <Typography
                                variant="h6"
                                style={{
                                    margin: "0 10px",
                                    color: "#ccc",
                                    fontWeight: "600"
                                }}
                            >
                                OR
                            </Typography>
                            <Divider style={{ width: '40%', backgroundColor: "#DD9854" }} />
                        </Box>}

                        {false && <Box
                            display="flex"
                            justifyContent="center"
                            mb={2}
                        >
                            {isGoogleLoading ? (
                                <CircularProgress size={24} style={{ color: "#654321" }} />
                            ) : (
                                <div style={{ maxWidth: '340px', fontSize: '1.2em', fontWeight: "bold" }}>
                                    <GoogleOAuthProvider clientId="20661248742-cjc0h0oe53jv5tda1nbva58f6fp1tib5.apps.googleusercontent.com">
                                        <GoogleLogin
                                            onSuccess={handleGoogleSuccess}
                                            onError={handleGoogleError}
                                            text="Sign in with Google"
                                            shape="rectangular"
                                            logo_alignment="left"
                                            width="100%"
                                        />
                                    </GoogleOAuthProvider>
                                </div>
                            )}
                        </Box>}
                        {false && <Button
                            variant="outlined"
                            fullWidth
                            onClick={skipLogin}
                            style={{

                                color: '#000',
                                borderRadius: "8px",
                                padding: "10px",
                                fontWeight: "bold",
                                textTransform: "uppercase",
                                marginTop: "20px"
                            }}
                        >
                            Continue as guest
                        </Button>}

                    </div>
                )}

                {/* OTP Verification Screen */}
                {otpSent && (
                    <div id="input_otp" style={{ width: "100%" }}>
                        <Typography
                            variant="h6"
                            align="center"
                            id="hint-text"
                            gutterBottom
                            style={{
                                color: setting.themeTxtColor,
                                fontWeight: "400",
                                fontFamily: setting.themePrimaryFontFam
                            }}
                        >
                            {passHint}
                        </Typography>

                        {false && <Typography
                            variant="span"

                            align="center"
                            paragraph
                            style={{ color: setting.themeTxtColor, paddingTop: "2em", fontFamily: setting.themeSecondaryFontFam, lineHeight: 1.5 }}
                        >

                        </Typography>}

                        <Box textAlign="center" mt={2} display="flex" justifyContent="center" gap="10px">
                            {otp.map((digit, index) => (
                                <TextField
                                    key={index}
                                    inputRef={(el) => (inputRefs.current[index] = el)}
                                    required
                                    variant="outlined"
                                    margin="normal"
                                    value={digit}
                                    onChange={(e) => handleOtpChange(index, e.target.value)}
                                    onKeyDown={(e) => handleOtpKeyDown(index, e)}
                                    style={{
                                        width: "50px",
                                        margin: "10px 5px 20px",
                                        fontSize: "1.2em",
                                        backgroundColor: "#2a2a2a",
                                        borderRadius: "8px",
                                        textAlign: "center"
                                    }}
                                    inputProps={{
                                        maxLength: 1,
                                        style: { textAlign: 'center', color: '#6f6d6d', fontSize: '1.2em' }
                                    }}
                                />
                            ))}

                            {false && <Typography
                                variant="body2"
                                style={{ color: "#ffff", padding: '8px 0' }}
                            >
                                {timer === 0 ? (
                                    <Button
                                        onClick={getOtpHandler}
                                        variant="text"
                                        style={{
                                            color: "#ffff",
                                            textTransform: 'none',
                                            fontFamily: setting.themeSecondaryFontFam,
                                        }}
                                    >
                                        Click here to resend OTP
                                    </Button>
                                ) : (
                                    `Resend OTP in ${timer} seconds`
                                )}
                            </Typography>}
                        </Box>

                        <Box textAlign="center" mt={2}>
                            <Button
                                onClick={verifyOtpHandler}
                                variant="contained"
                                disabled={isVerifyingOtp || otp.join("").length < 4}
                                style={{
                                    width: "70%",
                                    padding: "10px",
                                    backgroundColor: setting.themeTxtColor, // ✅ Fixed: single '#'
                                    color: setting.themeColor,
                                    fontFamily: setting.themeSecondaryFontFam,
                                    borderRadius: "8px",
                                    fontWeight: "bold",
                                }}
                            >
                                {isVerifyingOtp ? <CircularProgress size={24} style={{ color: "#543A20" }} /> : "NEXT >>"}
                            </Button>
                        </Box>

                        <Box textAlign="center" mt={2}>
                            <Button
                                onClick={handleChangeEmail}
                                variant="text"
                                style={{
                                    color: "#ffff",
                                    textTransform: 'none',
                                    fontFamily: setting.themeSecondaryFontFam
                                }}
                            >
                                Change Phone Number
                            </Button>
                        </Box>
                    </div>
                )}
            </div>
        </Box>
    );
};

export default SignUp;